import ButtonGroup from "../partials/ButtonGroup";
import {SbBlokData, storyblokEditable} from "@storyblok/react";

interface IProps {
    blok: { class: string } & SbBlokData
}

export default function Padding(props: IProps) {
    const blok = props.blok;

    return (
        <div className={blok.class} {...storyblokEditable(blok)}>

        </div>
    )
}
